module.exports = __webpack_public_path__ + "img/zhongYao4.f0294280.png";